import { useState } from "react";
import { FiX } from "react-icons/fi";
import { Oval } from "react-loader-spinner";

import MultiSelectChipInput from "src/Pages/Setting/Report/components/MultiSelectChipInput";

// Change the locations a customer app user (or pending invite) is assigned to.
function EditLocationsModal({ userLabel, locationOptions, initialIds, onSaveClicked, onCancelClicked }) {
  const [locationIds, setLocationIds] = useState(initialIds || []);
  const [submitted, setSubmitted] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const locationError = submitted && locationIds.length === 0;

  const saveClicked = async () => {
    if (isSaving) return;
    setSubmitted(true);
    if (locationIds.length === 0) return;
    setIsSaving(true);
    try {
      await onSaveClicked(locationIds);
    } finally {
      setIsSaving(false);
    }
  };

  const cancelClicked = () => {
    if (isSaving) return;
    onCancelClicked();
  };

  return (
    <div
      onClick={cancelClicked}
      className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[672px] max-w-full max-h-[90vh] bg-white rounded-[12px] shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)] flex flex-col"
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E8F3]">
          <div className="flex flex-col">
            <h2 className="text-[20px] leading-[28px] capitalize font-OpenSansSemiBold text-[#1A2332]">
              Edit Locations
            </h2>
            <p className="text-[14px] leading-[20px] font-OpenSansRegular text-[#868DA6]">
              {userLabel
                ? `Choose the locations ${userLabel} manages.`
                : "Choose the locations this user manages."}
            </p>
          </div>
          <FiX size={18} className="text-[#868DA6] cursor-pointer" onClick={cancelClicked} />
        </div>

        <div className="p-8 overflow-y-auto flex-1">
          <div className="flex flex-col gap-1">
            <MultiSelectChipInput
              label="Locations"
              options={locationOptions}
              selectedIds={locationIds}
              onChange={setLocationIds}
              placeholder="Search locations..."
            />
            {locationError && (
              <p className="text-[12px] text-red-500 font-OpenSansRegular">Select at least one location.</p>
            )}
          </div>
        </div>

        <div className="flex items-center justify-end gap-4 px-6 py-4 border-t border-[#E5E8F3]">
          <button
            type="button"
            onClick={cancelClicked}
            className={`h-[40px] px-1 rounded-[6px] text-[16px] leading-[24px] capitalize font-OpenSansSemiBold text-[#7C829A] ${
              isSaving ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={saveClicked}
            className={`h-[40px] px-4 rounded-[8px] text-[16px] leading-[24px] capitalize font-OpenSansSemiBold bg-blueColor text-white flex items-center justify-center ${
              isSaving ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            {isSaving ? (
              <Oval
                visible={true}
                height="18"
                width="18"
                color="#FFFFFF"
                strokeWidth={8}
                secondaryColor="#FFEEFF"
                ariaLabel="save-locations-loading"
              />
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditLocationsModal;
